<div class="popup-header">
  <div class="title">
    {{data.name}}
  </div>
</div>

<div mat-dialog-content>
  <br>


  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Name</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.name" disabled
      aria-describedby="inputGroup-sizing-sm">
  </div>
  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <label class="input-group-text" for="inputGroupSelect01">Subsidy Active</label>
    </div>
    <select class="custom-select" [(ngModel)]="data.subsidyActive" id="inputGroupSelect01">
      <option>Choose...</option>
      <option value="true">Yes</option>
      <option value="false">No</option>
    </select>
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Subsidy %</span>
    </div>
    <input type="number" class="form-control" aria-label="Small" [(ngModel)]="data.subsidy" value = 0
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <label class="input-group-text" for="inputGroupSelect02">Apply to guests (no login)</label>
    </div>
    <select class="custom-select" [(ngModel)]="data.subsidyForGuests" id="inputGroupSelect02">
      <option value="false">No</option>
      <option value="true">Yes</option>
    </select>
  </div>
  <small class="form-text text-muted mb-3">
    By default only logged-in users get the category subsidy. Set Yes to give the same subsidy to guests at this site.
  </small>



</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
  <button class="theme-button" (click)="updateCategory(data)" cdkFocusInitial>Save</button>
</div>